/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Instant_ServiceInputs */

const en_fulfillment_instant_service = /** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant Service Delivery`)
};

const id_fulfillment_instant_service = /** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengiriman Layanan Instan`)
};

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const es_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const fr_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const de_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const ja_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const zh_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const ar_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const it_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const ru_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const pt_fulfillment_instant_service = en_fulfillment_instant_service;

/** @type {(inputs: Fulfillment_Instant_ServiceInputs) => LocalizedString} */
const ko_fulfillment_instant_service = en_fulfillment_instant_service;

/**
* | output |
* | --- |
* | "Instant Service Delivery" |
*
* @param {Fulfillment_Instant_ServiceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_instant_service = /** @type {((inputs?: Fulfillment_Instant_ServiceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Instant_ServiceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_instant_service(inputs)
	if (locale === "es") return es_fulfillment_instant_service(inputs)
	if (locale === "fr") return fr_fulfillment_instant_service(inputs)
	if (locale === "de") return de_fulfillment_instant_service(inputs)
	if (locale === "ja") return ja_fulfillment_instant_service(inputs)
	if (locale === "zh") return zh_fulfillment_instant_service(inputs)
	if (locale === "ar") return ar_fulfillment_instant_service(inputs)
	if (locale === "id") return id_fulfillment_instant_service(inputs)
	if (locale === "it") return it_fulfillment_instant_service(inputs)
	if (locale === "ru") return ru_fulfillment_instant_service(inputs)
	if (locale === "pt") return pt_fulfillment_instant_service(inputs)
	return ko_fulfillment_instant_service(inputs)
});